module.exports = __webpack_public_path__ + "img/logo-ofis-footer.07d8026e.svg";